import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Loading from '../../../common/component/Loading'
import ReactStringReplace from 'react-string-replace'
import Window from '../../../common/Window'

class SurveySettingList extends Component {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false, surveySettingList: [], isOutputCsvModalOpen: false, isOutputTotalModalOpen: false, targetSurvey:''}
    this.toggleOutputCsvModal = this.toggleOutputCsvModal.bind(this)
    this.toggleOutputTotalModal = this.toggleOutputTotalModal.bind(this)
  }
  componentDidMount () {
    this.SurveySettingList()
  }
  selected (survey, e) {
    this.props.history.push('/' + this.userRoleUrl + '/survey_setting/edit/' + survey.id)
  }
  toggleOutputCsvModal(surveyId) {
    this.setState((prevState) => ({
      isOutputCsvModalOpen: !prevState.isOutputCsvModalOpen,
      targetSurvey: surveyId
    }))
  }
  toggleOutputTotalModal(surveyId) {
    this.setState((prevState) => ({
      isOutputTotalModalOpen: !prevState.isOutputTotalModalOpen,
      targetSurvey: surveyId
    }))
  }
  onOutputCsvButtonClicked (action, e) {
    e.preventDefault()
    let confirmMsg = ''
    const survey = this.state.surveySettingList.find(item => item.id === this.state.targetSurvey)
    switch (action) {
      case 'katawaku' :
      case 'kaitai' :
      case 'other' :
        if(survey.shimeFlg) {
          confirmMsg = 'アンケート結果をダウンロードします。\nよろしいですか？'
        } else {
          confirmMsg = 'アンケートの途中結果をダウンロードします。\nよろしいですか？'
        }
        Window.confirm(confirmMsg, () => {
          this.outputCsv(action, survey.id)
          Window.closeDialog()
        })
        break
      case 'cancel' :
        this.setState({ isOutputCsvModalOpen: false })
        break
      default:
        break
    }
  }
  onOutputTotalButtonClicked (action, e) {
    e.preventDefault()
    let confirmMsg = ''
    const survey = this.state.surveySettingList.find(item => item.id === this.state.targetSurvey)
    switch (action) {
      case 'katawaku' :
      case 'kaitai' :
      case 'other' :
        if(survey.shimeFlg) {
          confirmMsg = 'アンケート集計結果をダウンロードします。\nよろしいですか？'
        } else {
          confirmMsg = 'アンケートの途中集計結果をダウンロードします。\nよろしいですか？'
        }
        Window.confirm(confirmMsg, () => {
          this.outputTotalCsv(action, survey.id)
          Window.closeDialog()
        })
        break
      case 'cancel' :
        this.setState({ isOutputTotalModalOpen: false })
        break
      default:
        break
    }
  }
  outputCsv(action, id) {
    const onSuccessToGet = (res) => {
      const choiseData = res.body.data.surveyChoises
      const questionData = res.body.data.surveySmallQuestions
      const answerData = res.body.data.surveyAnswers
      // `createDateTime` を一度数値に変換してソート
      const sortedAnswerData = answerData.sort((a, b) => {
        // 数値に変換
        const dateA = Number(a.createDateTime);
        const dateB = Number(b.createDateTime);

        // 昇順ソート (新しい日付が上に来る)
        return dateA - dateB;
      });
      // ヘッダー（questionId の一覧）を作成
      const questionIds = questionData.map(question => question.id)
      let headers1 = []
      let headers2 = []
      switch(action) {
        case 'katawaku':
          headers1 = ['１ー７','１ー２','１ー６','１ー１','質問１　就業者数',,,,,,,,,,,,,'質問１　就業者数',,,,,,,,,,,,,'質問１　就業者数',,,,,,,,,,,,,
                      '質問２　入職者数',,,,,,,,,,,,,'質問２　入職者数',,,,,,,,,,,,,'質問２　入職者数',,,,,,,,,,,,,
                      '質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金'
                     ]
          headers2 = ['支部','会社所在都道府県','会員/会員外','会社名',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '各年代小計１15-19歳','各年代小計１20-24歳','各年代小計１25-29歳','各年代小計１30-34歳','各年代小計１35-39歳','各年代小計１40-44歳','各年代小計１45-49歳',
                      '各年代小計１50-54歳','各年代小計１55-59歳','各年代小計１60-64歳','各年代小計１65-69歳','各年代小計１70歳以上','各年代小計１合計',
                      '日本人入職者15-19歳','日本人入職者20-24歳','日本人入職者25-29歳','日本人入職者30-34歳','日本人入職者35-39歳','日本人入職者40-44歳','日本人入職者45-49歳',
                      '日本人入職者50-54歳','日本人入職者55-59歳','日本人入職者60-64歳','日本人入職者65-69歳','日本人入職者70歳以上','日本人入職者合計',
                      '外国人入職者15-19歳','外国人入職者20-24歳','外国人入職者25-29歳','外国人入職者30-34歳','外国人入職者35-39歳','外国人入職者40-44歳','外国人入職者45-49歳',
                      '外国人入職者50-54歳','外国人入職者55-59歳','外国人入職者60-64歳','外国人入職者65-69歳','外国人入職者70歳以上','外国人入職者合計',
                      '各年代小計２15-19歳','各年代小計２20-24歳','各年代小計２25-29歳','各年代小計２30-34歳','各年代小計２35-39歳','各年代小計２40-44歳','各年代小計２45-49歳',
                      '各年代小計２50-54歳','各年代小計２55-59歳','各年代小計２60-64歳','各年代小計２65-69歳','各年代小計２70歳以上','各年代小計２合計',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '適用除外15-19歳','適用除外20-24歳','適用除外25-29歳','適用除外30-34歳','適用除外35-39歳','適用除外40-44歳','適用除外45-49歳',
                      '適用除外50-54歳','適用除外55-59歳','適用除外60-64歳','適用除外65-69歳','適用除外70歳以上','適用除外合計',
                      '未加入不明15-19歳','未加入不明20-24歳','未加入不明25-29歳','未加入不明30-34歳','未加入不明35-39歳','未加入不明40-44歳','未加入不明45-49歳',
                      '未加入不明50-54歳','未加入不明55-59歳','未加入不明60-64歳','未加入不明65-69歳','未加入不明70歳以上','未加入不明合計',
                      '各年代小計３15-19歳','各年代小計３20-24歳','各年代小計３25-29歳','各年代小計３30-34歳','各年代小計３35-39歳','各年代小計３40-44歳','各年代小計３45-49歳',
                      '各年代小計３50-54歳','各年代小計３55-59歳','各年代小計３60-64歳','各年代小計３65-69歳','各年代小計３70歳以上','各年代小計３合計'
                     ]
          break
        case 'kaitai':
          headers1 = ['１ー７','１ー２','１ー６','１ー１','質問４就業者数',,,,,,,,,,,,,'質問４就業者数',,,,,,,,,,,,,'質問４就業者数',,,,,,,,,,,,,
                      '質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金'
                     ]
          headers2 = ['支部','会社所在都道府県','会員/会員外','会社名',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '各年代小計４15-19歳','各年代小計４20-24歳','各年代小計４25-29歳','各年代小計４30-34歳','各年代小計４35-39歳','各年代小計４40-44歳','各年代小計４45-49歳',
                      '各年代小計４50-54歳','各年代小計４55-59歳','各年代小計４60-64歳','各年代小計４65-69歳','各年代小計４70歳以上','各年代小計４合計',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '適用除外15-19歳','適用除外20-24歳','適用除外25-29歳','適用除外30-34歳','適用除外35-39歳','適用除外40-44歳','適用除外45-49歳',
                      '適用除外50-54歳','適用除外55-59歳','適用除外60-64歳','適用除外65-69歳','適用除外70歳以上','適用除外合計',
                      '未加入不明者15-19歳','未加入不明者20-24歳','未加入不明者25-29歳','未加入不明者30-34歳','未加入不明者35-39歳','未加入不明者40-44歳','未加入不明者45-49歳',
                      '未加入不明者50-54歳','未加入不明者55-59歳','未加入不明者60-64歳','未加入不明者65-69歳','未加入不明者70歳以上','未加入不明者合計',
                      '各年代小計５15-19歳','各年代小計５20-24歳','各年代小計５25-29歳','各年代小計５30-34歳','各年代小計５35-39歳','各年代小計５40-44歳','各年代小計５45-49歳',
                      '各年代小計５50-54歳','各年代小計５55-59歳','各年代小計５60-64歳','各年代小計５65-69歳','各年代小計５70歳以上','各年代小計５合計'
                     ]
          break
        case 'other':
          headers1 = ['１ー７','１ー２','１ー６','１ー１','２ー３質問６',,'２ー３質問７',,
                      '２ー４質問８',,,'２ー４質問９',,,'２ー５質問１０',,,,,
                      '２ー６質問１１','２ー６質問１２',,,'２ー６質問１２',,,'２ー６質問１３'
                     ]
          headers2 = ['支部','会社所在都道府県','会員/会員外','会社名',
                    '型枠工職長日給（円）','型枠工技能工日給（円）',
                    '解体工職長日給（円）','解体工技能工日給（円）',
                    '(1)型枠工需要予測現在','(2)型枠工需要予測３ヵ月後','(3)型枠工需要予測５ヵ月後',
                    '(1)解体工需要予測現在','(2)解体工需要予測３ヵ月後','(3)解体工需要予測５ヵ月後',
                    '月給制①','日給制②','日給月給制③','その他④','その他④文章',
                    '事業者情報の登録状況',
                    '（１）工事現場数①','（１）工事現場数②','（１）工事現場数③','（２）工事現場数①','（２）工事現場数②','（２）工事現場数③',
                    '活用①','活用②','活用③','活用④','活用⑤','活用⑥','活用⑦','活用⑧','活用⑧その他記入欄'
                    ]
          break
        default:
          break
      }

      // データ行を作成
      const rows = sortedAnswerData.map(item => {
        const answers = questionIds.reduce((acc, qId) => {
          if (Array.isArray(item.answerData)) {
            const answerObj = item.answerData.find((answer) => 
              String(answer.questionId) === String(qId)
            );
            // answerをセット、見つからない場合は空文字
            acc[qId] = answerObj ? answerObj.answer : null;
          }
          return acc;
        }, {})
        let datas = []
        switch(action) {
          case 'katawaku':
            datas = [
              (() => {
                const answer = choiseData[3].find(choise => choise.choise_sort == answers[8]);
                return answer ? answer.choise_text : null;
              })(),
              (() => {
                const answer = choiseData[2].find(choise => choise.choise_sort == answers[2]);
                return answer ? answer.choise_text : null;
              })(),
              answers[7]==1?'会員':'会員外',answers[1],
              answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],
              answers[15],answers[16],answers[17],answers[18],answers[19],answers[20],
              [answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],answers[15],answers[16],
               answers[17],answers[18],answers[19],answers[20]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[21],answers[22],answers[23],answers[24],answers[25],answers[26],
              answers[27],answers[28],answers[29],answers[30],answers[31],answers[32],
              [answers[21],answers[22],answers[23],answers[24],answers[25],answers[26],answers[27],answers[28],
               answers[29],answers[30],answers[31],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[9],answers[21]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[10],answers[22]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[11],answers[23]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[12],answers[24]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[13],answers[25]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[14],answers[26]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[15],answers[27]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[16],answers[28]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[17],answers[29]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[18],answers[30]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[19],answers[31]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[20],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],answers[15],
               answers[16],answers[17],answers[18],answers[19],answers[20],answers[21],answers[22],
               answers[23],answers[24],answers[25],answers[26],answers[27],answers[28],answers[29],
               answers[30],answers[31],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],
              answers[39],answers[40],answers[41],answers[42],answers[43],answers[44],
              [answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],answers[39],answers[40],
               answers[41],answers[42],answers[43],answers[44]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[45],answers[46],answers[47],answers[48],answers[49],answers[50],
              answers[51],answers[52],answers[53],answers[54],answers[55],answers[56],
              [answers[45],answers[46],answers[47],answers[48],answers[49],answers[50],answers[51],answers[52],
               answers[53],answers[54],answers[55],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[33],answers[45]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[34],answers[46]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[35],answers[47]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[36],answers[48]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[37],answers[49]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[38],answers[50]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[39],answers[51]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[40],answers[52]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[41],answers[53]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[42],answers[54]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[43],answers[55]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[44],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],answers[39],
               answers[40],answers[41],answers[42],answers[43],answers[44],answers[45],answers[46],
               answers[47],answers[48],answers[49],answers[50],answers[51],answers[52],answers[53],
               answers[54],answers[55],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],
              answers[63],answers[64],answers[65],answers[66],answers[67],answers[68],
              [answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],answers[63],answers[64],
               answers[65],answers[66],answers[67],answers[68]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[69],answers[70],answers[71],answers[72],answers[73],answers[74],
              answers[75],answers[76],answers[77],answers[78],answers[79],answers[80],
              [answers[69],answers[70],answers[71],answers[72],answers[73],answers[74],answers[75],answers[76],
               answers[77],answers[78],answers[79],answers[80]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[81],answers[82],answers[83],answers[84],answers[85],answers[86],
              answers[87],answers[88],answers[89],answers[90],answers[91],answers[92],
              [answers[81],answers[82],answers[83],answers[84],answers[85],answers[86],answers[87],answers[88],
               answers[89],answers[90],answers[91],answers[92]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],
              answers[99],answers[100],answers[101],answers[102],answers[103],answers[104],
              [answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],answers[99],answers[100],
               answers[101],answers[102],answers[103],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[57],answers[69],answers[81],answers[93]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[58],answers[70],answers[82],answers[94]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[59],answers[71],answers[83],answers[95]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[60],answers[72],answers[84],answers[96]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[61],answers[73],answers[85],answers[97]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[62],answers[74],answers[86],answers[98]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[63],answers[75],answers[87],answers[99]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[64],answers[76],answers[88],answers[100]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[65],answers[77],answers[89],answers[101]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[66],answers[78],answers[90],answers[102]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[67],answers[79],answers[91],answers[103]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[68],answers[80],answers[92],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],answers[63],
               answers[64],answers[65],answers[66],answers[67],answers[68],answers[69],answers[70],
               answers[71],answers[72],answers[73],answers[74],answers[75],answers[76],answers[77],
               answers[78],answers[79],answers[80],answers[81],answers[82],answers[83],answers[84],
               answers[85],answers[86],answers[87],answers[88],answers[89],answers[90],answers[91],
               answers[92],answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],
               answers[99],answers[100],answers[101],answers[102],answers[103],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
            ]
            break
          case 'kaitai':
            datas = [
              (() => {
                const answer = choiseData[3].find(choise => choise.choise_sort == answers[8]);
                return answer ? answer.choise_text : null;
              })(),
              (() => {
                const answer = choiseData[2].find(choise => choise.choise_sort == answers[2]);
                return answer ? answer.choise_text : null;
              })(),
              answers[7]==1?'会員':'会員外',answers[1],
              answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],
              answers[111],answers[112],answers[113],answers[114],answers[115],answers[116],
              [answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],answers[111],answers[112],
               answers[113],answers[114],answers[115],answers[116]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[117],answers[118],answers[119],answers[120],answers[121],answers[122],
              answers[123],answers[124],answers[125],answers[126],answers[127],answers[128],
              [answers[117],answers[118],answers[119],answers[120],answers[121],answers[122],answers[123],answers[124],
               answers[125],answers[126],answers[127],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[105],answers[117]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[106],answers[118]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[107],answers[119]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[108],answers[120]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[109],answers[121]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[110],answers[122]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[111],answers[123]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[112],answers[124]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[113],answers[125]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[114],answers[126]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[115],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[116],answers[129]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],answers[111],
               answers[112],answers[113],answers[114],answers[115],answers[116],answers[117],answers[118],
               answers[119],answers[120],answers[121],answers[122],answers[123],answers[124],answers[125],
               answers[126],answers[127],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],
              answers[135],answers[136],answers[137],answers[138],answers[139],answers[140],
              [answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],answers[135],answers[136],
               answers[137],answers[138],answers[139],answers[140]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[141],answers[142],answers[143],answers[144],answers[145],answers[146],
              answers[147],answers[148],answers[149],answers[150],answers[151],answers[152],
              [answers[141],answers[142],answers[143],answers[144],answers[145],answers[146],answers[147],answers[148],
               answers[149],answers[150],answers[151],answers[152]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],
              answers[159],answers[160],answers[161],answers[162],answers[163],answers[164],
              [answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],answers[159],answers[160],
               answers[161],answers[162],answers[163],answers[164]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[165],answers[166],answers[167],answers[168],answers[169],answers[170],
              answers[171],answers[172],answers[173],answers[174],answers[175],answers[176],
              [answers[165],answers[166],answers[167],answers[168],answers[169],answers[170],answers[171],answers[172],
               answers[173],answers[174],answers[175],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[129],answers[141],answers[153],answers[165]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[130],answers[142],answers[154],answers[166]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[131],answers[143],answers[155],answers[167]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[132],answers[144],answers[156],answers[168]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[133],answers[145],answers[157],answers[169]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[134],answers[146],answers[158],answers[170]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[135],answers[147],answers[159],answers[171]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[136],answers[148],answers[160],answers[172]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[137],answers[149],answers[161],answers[173]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[138],answers[150],answers[162],answers[174]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[139],answers[151],answers[163],answers[175]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[140],answers[152],answers[164],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],
              answers[135],answers[136],answers[137],answers[138],answers[139],answers[140],answers[141],answers[142],
              answers[143],answers[144],answers[145],answers[146],answers[147],answers[148],answers[149],answers[150],
              answers[151],answers[152],answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],
              answers[159],answers[160],answers[161],answers[162],answers[163],answers[164],answers[165],answers[166],
              answers[167],answers[168],answers[169],answers[170],answers[171],answers[172],answers[173],answers[174],
              answers[175],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
            ]
            break
          case 'other':
            datas = [
              (() => {
                const answer = choiseData[3].find(choise => choise.choise_sort == answers[8]);
                return answer ? answer.choise_text : null;
              })(),
              (() => {
                const answer = choiseData[2].find(choise => choise.choise_sort == answers[2]);
                return answer ? answer.choise_text : null;
              })(),
              answers[7]==1?'会員':'会員外',answers[1],
              answers[177],answers[178],answers[179],answers[180],
              answers[181],answers[182],answers[183],
              answers[184],answers[185],answers[186],
              answers[187],answers[188],answers[189],answers[190],answers[191] ? answers[191].replace(/\n/g, '') : null,
              answers[192],
              answers[193],answers[194],answers[195],
              answers[196],answers[197],answers[198],
              answers[199],answers[200],answers[201],answers[202],answers[203],answers[204],answers[205],answers[206],
              answers[207] ? answers[207].replace(/\n/g, '') : null,
            ]
            const answersArray = Object.keys(answers)
              .map(key => Number(key)).sort((a, b) => a - b)
              .map(key => answers[key])
            datas = datas.concat(
              answersArray.slice(207).filter(answer => answer !== undefined && answer !== null)
            )
            break
        }
        return datas;
      });

      const csvContent = [
        headers1.join(','), // ヘッダー行
        headers2.join(','), // ヘッダー行
        ...rows.map(row => row.join(',')) // 各データ行
      ].join('\n'); // 改行で結合

      // UTF-8 BOMを追加
      const bom = '\uFEFF';
      const csvWithBom = bom + csvContent;
      // CSV ファイルのダウンロード
      const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${action}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const paramsToGet = {
      command: 'resultget',
      output: action,
      id: id
    };
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet);
  }

  outputTotalCsv(action, id) {
    const onSuccessToGet = (res) => {
      const choiseData = res.body.data.surveyChoises
      const questionData = res.body.data.surveySmallQuestions
      const answerData = res.body.data.surveyAnswers
      // ヘッダー（questionId の一覧）を作成
      const questionIds = questionData.map(question => question.id)
      let headers1 = []
      let headers2 = []
      let datas = []
      switch(action) {
        case 'katawaku':
          headers1 = ['１ー７','質問１　就業者数',,,,,,,,,,,,,'質問１　就業者数',,,,,,,,,,,,,'質問１　就業者数',,,,,,,,,,,,,
                      '質問２　入職者数',,,,,,,,,,,,,'質問２　入職者数',,,,,,,,,,,,,'質問２　入職者数',,,,,,,,,,,,,
                      '質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金',,,,,,,,,,,,,'質問３厚生年金'
                     ]
          headers2 = ['支部',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '各年代小計１15-19歳','各年代小計１20-24歳','各年代小計１25-29歳','各年代小計１30-34歳','各年代小計１35-39歳','各年代小計１40-44歳','各年代小計１45-49歳',
                      '各年代小計１50-54歳','各年代小計１55-59歳','各年代小計１60-64歳','各年代小計１65-69歳','各年代小計１70歳以上','各年代小計１合計',
                      '日本人入職者15-19歳','日本人入職者20-24歳','日本人入職者25-29歳','日本人入職者30-34歳','日本人入職者35-39歳','日本人入職者40-44歳','日本人入職者45-49歳',
                      '日本人入職者50-54歳','日本人入職者55-59歳','日本人入職者60-64歳','日本人入職者65-69歳','日本人入職者70歳以上','日本人入職者合計',
                      '外国人入職者15-19歳','外国人入職者20-24歳','外国人入職者25-29歳','外国人入職者30-34歳','外国人入職者35-39歳','外国人入職者40-44歳','外国人入職者45-49歳',
                      '外国人入職者50-54歳','外国人入職者55-59歳','外国人入職者60-64歳','外国人入職者65-69歳','外国人入職者70歳以上','外国人入職者合計',
                      '各年代小計２15-19歳','各年代小計２20-24歳','各年代小計２25-29歳','各年代小計２30-34歳','各年代小計２35-39歳','各年代小計２40-44歳','各年代小計２45-49歳',
                      '各年代小計２50-54歳','各年代小計２55-59歳','各年代小計２60-64歳','各年代小計２65-69歳','各年代小計２70歳以上','各年代小計２合計',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '適用除外15-19歳','適用除外20-24歳','適用除外25-29歳','適用除外30-34歳','適用除外35-39歳','適用除外40-44歳','適用除外45-49歳',
                      '適用除外50-54歳','適用除外55-59歳','適用除外60-64歳','適用除外65-69歳','適用除外70歳以上','適用除外合計',
                      '未加入不明15-19歳','未加入不明20-24歳','未加入不明25-29歳','未加入不明30-34歳','未加入不明35-39歳','未加入不明40-44歳','未加入不明45-49歳',
                      '未加入不明50-54歳','未加入不明55-59歳','未加入不明60-64歳','未加入不明65-69歳','未加入不明70歳以上','未加入不明合計',
                      '各年代小計３15-19歳','各年代小計３20-24歳','各年代小計３25-29歳','各年代小計３30-34歳','各年代小計３35-39歳','各年代小計３40-44歳','各年代小計３45-49歳',
                      '各年代小計３50-54歳','各年代小計３55-59歳','各年代小計３60-64歳','各年代小計３65-69歳','各年代小計３70歳以上','各年代小計３合計'
                     ]
          break
        case 'kaitai':
          headers1 = ['１ー７','質問４就業者数',,,,,,,,,,,,,'質問４就業者数',,,,,,,,,,,,,'質問４就業者数',,,,,,,,,,,,,
                      '質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金',,,,,,,,,,,,,'質問５厚生年金'
                     ]
          headers2 = ['支部',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '各年代小計４15-19歳','各年代小計４20-24歳','各年代小計４25-29歳','各年代小計４30-34歳','各年代小計４35-39歳','各年代小計４40-44歳','各年代小計４45-49歳',
                      '各年代小計４50-54歳','各年代小計４55-59歳','各年代小計４60-64歳','各年代小計４65-69歳','各年代小計４70歳以上','各年代小計４合計',
                      '日本人技能工15-19歳','日本人技能工20-24歳','日本人技能工25-29歳','日本人技能工30-34歳','日本人技能工35-39歳','日本人技能工40-44歳','日本人技能工45-49歳',
                      '日本人技能工50-54歳','日本人技能工55-59歳','日本人技能工60-64歳','日本人技能工65-69歳','日本人技能工70歳以上','日本人技能工合計',
                      '外国人技能工15-19歳','外国人技能工20-24歳','外国人技能工25-29歳','外国人技能工30-34歳','外国人技能工35-39歳','外国人技能工40-44歳','外国人技能工45-49歳',
                      '外国人技能工50-54歳','外国人技能工55-59歳','外国人技能工60-64歳','外国人技能工65-69歳','外国人技能工70歳以上','外国人技能工合計',
                      '適用除外15-19歳','適用除外20-24歳','適用除外25-29歳','適用除外30-34歳','適用除外35-39歳','適用除外40-44歳','適用除外45-49歳',
                      '適用除外50-54歳','適用除外55-59歳','適用除外60-64歳','適用除外65-69歳','適用除外70歳以上','適用除外合計',
                      '未加入不明者15-19歳','未加入不明者20-24歳','未加入不明者25-29歳','未加入不明者30-34歳','未加入不明者35-39歳','未加入不明者40-44歳','未加入不明者45-49歳',
                      '未加入不明者50-54歳','未加入不明者55-59歳','未加入不明者60-64歳','未加入不明者65-69歳','未加入不明者70歳以上','未加入不明者合計',
                      '各年代小計５15-19歳','各年代小計５20-24歳','各年代小計５25-29歳','各年代小計５30-34歳','各年代小計５35-39歳','各年代小計５40-44歳','各年代小計５45-49歳',
                      '各年代小計５50-54歳','各年代小計５55-59歳','各年代小計５60-64歳','各年代小計５65-69歳','各年代小計５70歳以上','各年代小計５合計'
                     ]
          break
        default:
          break
      }

      // データ行を作成
      const summaryData = {}
      const rows = answerData.map(item => {
        const answers = questionIds.reduce((acc, qId) => {
          if (Array.isArray(item.answerData)) {
            const answerObj = item.answerData.find((answer) => 
              String(answer.questionId) === String(qId)
            )
            // answerをセット、見つからない場合は空文字
            acc[qId] = answerObj ? answerObj.answer : null
          }
          return acc
        }, {})
        // 支部ごとのデータをサマリーする
        const branch = answers[8] || "不明"

        // 支部ごとの集計
        if (!summaryData[branch]) {
          summaryData[branch] = {};
        }

        // 集計
        for (let i = 9; i <= 176; i++) {
          const value = parseFloat(answers[String(i)]);
          if (!isNaN(value)) {
            summaryData[branch][i] = (summaryData[branch][i] || 0) + value;
          }
        }
        return summaryData;
      });
      Object.entries(summaryData).map(([branch, answers]) => {
        switch(action) {
          case 'katawaku':
            datas.push([
              (() => {
                const answer = choiseData[3].find(choise => choise.choise_sort == branch);
                return answer ? answer.choise_text : "不明";
              })(),
              answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],
              answers[15],answers[16],answers[17],answers[18],answers[19],answers[20],
              [answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],answers[15],answers[16],
               answers[17],answers[18],answers[19],answers[20]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[21],answers[22],answers[23],answers[24],answers[25],answers[26],
              answers[27],answers[28],answers[29],answers[30],answers[31],answers[32],
              [answers[21],answers[22],answers[23],answers[24],answers[25],answers[26],answers[27],answers[28],
               answers[29],answers[30],answers[31],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[9],answers[21]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[10],answers[22]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[11],answers[23]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[12],answers[24]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[13],answers[25]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[14],answers[26]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[15],answers[27]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[16],answers[28]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[17],answers[29]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[18],answers[30]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[19],answers[31]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[20],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[9],answers[10],answers[11],answers[12],answers[13],answers[14],answers[15],
               answers[16],answers[17],answers[18],answers[19],answers[20],answers[21],answers[22],
               answers[23],answers[24],answers[25],answers[26],answers[27],answers[28],answers[29],
               answers[30],answers[31],answers[32]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],
              answers[39],answers[40],answers[41],answers[42],answers[43],answers[44],
              [answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],answers[39],answers[40],
               answers[41],answers[42],answers[43],answers[44]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[45],answers[46],answers[47],answers[48],answers[49],answers[50],
              answers[51],answers[52],answers[53],answers[54],answers[55],answers[56],
              [answers[45],answers[46],answers[47],answers[48],answers[49],answers[50],answers[51],answers[52],
               answers[53],answers[54],answers[55],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[33],answers[45]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[34],answers[46]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[35],answers[47]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[36],answers[48]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[37],answers[49]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[38],answers[50]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[39],answers[51]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[40],answers[52]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[41],answers[53]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[42],answers[54]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[43],answers[55]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[44],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[33],answers[34],answers[35],answers[36],answers[37],answers[38],answers[39],
               answers[40],answers[41],answers[42],answers[43],answers[44],answers[45],answers[46],
               answers[47],answers[48],answers[49],answers[50],answers[51],answers[52],answers[53],
               answers[54],answers[55],answers[56]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],
              answers[63],answers[64],answers[65],answers[66],answers[67],answers[68],
              [answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],answers[63],answers[64],
               answers[65],answers[66],answers[67],answers[68]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[69],answers[70],answers[71],answers[72],answers[73],answers[74],
              answers[75],answers[76],answers[77],answers[78],answers[79],answers[80],
              [answers[69],answers[70],answers[71],answers[72],answers[73],answers[74],answers[75],answers[76],
               answers[77],answers[78],answers[79],answers[80]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[81],answers[82],answers[83],answers[84],answers[85],answers[86],
              answers[87],answers[88],answers[89],answers[90],answers[91],answers[92],
              [answers[81],answers[82],answers[83],answers[84],answers[85],answers[86],answers[87],answers[88],
               answers[89],answers[90],answers[91],answers[92]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],
              answers[99],answers[100],answers[101],answers[102],answers[103],answers[104],
              [answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],answers[99],answers[100],
               answers[101],answers[102],answers[103],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[57],answers[69],answers[81],answers[93]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[58],answers[70],answers[82],answers[94]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[59],answers[71],answers[83],answers[95]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[60],answers[72],answers[84],answers[96]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[61],answers[73],answers[85],answers[97]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[62],answers[74],answers[86],answers[98]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[63],answers[75],answers[87],answers[99]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[64],answers[76],answers[88],answers[100]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[65],answers[77],answers[89],answers[101]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[66],answers[78],answers[90],answers[102]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[67],answers[79],answers[91],answers[103]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[68],answers[80],answers[92],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[57],answers[58],answers[59],answers[60],answers[61],answers[62],answers[63],
               answers[64],answers[65],answers[66],answers[67],answers[68],answers[69],answers[70],
               answers[71],answers[72],answers[73],answers[74],answers[75],answers[76],answers[77],
               answers[78],answers[79],answers[80],answers[81],answers[82],answers[83],answers[84],
               answers[85],answers[86],answers[87],answers[88],answers[89],answers[90],answers[91],
               answers[92],answers[93],answers[94],answers[95],answers[96],answers[97],answers[98],
               answers[99],answers[100],answers[101],answers[102],answers[103],answers[104]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
            ])
            break
          case 'kaitai':
            datas.push([
              (() => {
                const answer = choiseData[3].find(choise => choise.choise_sort == branch);
                return answer ? answer.choise_text : "不明";
              })(),
              answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],
              answers[111],answers[112],answers[113],answers[114],answers[115],answers[116],
              [answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],answers[111],answers[112],
               answers[113],answers[114],answers[115],answers[116]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[117],answers[118],answers[119],answers[120],answers[121],answers[122],
              answers[123],answers[124],answers[125],answers[126],answers[127],answers[128],
              [answers[117],answers[118],answers[119],answers[120],answers[121],answers[122],answers[123],answers[124],
               answers[125],answers[126],answers[127],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              [answers[105],answers[117]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[106],answers[118]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[107],answers[119]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[108],answers[120]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[109],answers[121]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[110],answers[122]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[111],answers[123]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[112],answers[124]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[113],answers[125]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[114],answers[126]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[115],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[116],answers[129]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[105],answers[106],answers[107],answers[108],answers[109],answers[110],answers[111],
               answers[112],answers[113],answers[114],answers[115],answers[116],answers[117],answers[118],
               answers[119],answers[120],answers[121],answers[122],answers[123],answers[124],answers[125],
               answers[126],answers[127],answers[128]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),

              answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],
              answers[135],answers[136],answers[137],answers[138],answers[139],answers[140],
              [answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],answers[135],answers[136],
               answers[137],answers[138],answers[139],answers[140]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[141],answers[142],answers[143],answers[144],answers[145],answers[146],
              answers[147],answers[148],answers[149],answers[150],answers[151],answers[152],
              [answers[141],answers[142],answers[143],answers[144],answers[145],answers[146],answers[147],answers[148],
               answers[149],answers[150],answers[151],answers[152]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],
              answers[159],answers[160],answers[161],answers[162],answers[163],answers[164],
              [answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],answers[159],answers[160],
               answers[161],answers[162],answers[163],answers[164]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              answers[165],answers[166],answers[167],answers[168],answers[169],answers[170],
              answers[171],answers[172],answers[173],answers[174],answers[175],answers[176],
              [answers[165],answers[166],answers[167],answers[168],answers[169],answers[170],answers[171],answers[172],
               answers[173],answers[174],answers[175],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[129],answers[141],answers[153],answers[165]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[130],answers[142],answers[154],answers[166]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[131],answers[143],answers[155],answers[167]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[132],answers[144],answers[156],answers[168]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[133],answers[145],answers[157],answers[169]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[134],answers[146],answers[158],answers[170]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[135],answers[147],answers[159],answers[171]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[136],answers[148],answers[160],answers[172]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[137],answers[149],answers[161],answers[173]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[138],answers[150],answers[162],answers[174]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[139],answers[151],answers[163],answers[175]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[140],answers[152],answers[164],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
              [answers[129],answers[130],answers[131],answers[132],answers[133],answers[134],
              answers[135],answers[136],answers[137],answers[138],answers[139],answers[140],answers[141],answers[142],
              answers[143],answers[144],answers[145],answers[146],answers[147],answers[148],answers[149],answers[150],
              answers[151],answers[152],answers[153],answers[154],answers[155],answers[156],answers[157],answers[158],
              answers[159],answers[160],answers[161],answers[162],answers[163],answers[164],answers[165],answers[166],
              answers[167],answers[168],answers[169],answers[170],answers[171],answers[172],answers[173],answers[174],
              answers[175],answers[176]].map(a => Number(a || 0)).reduce((total, num) => total + num, 0),
            ])
            break
        }
        return datas;
      });

      const csvContent = [
        headers1.join(','), // ヘッダー行
        headers2.join(','), // ヘッダー行
        ...datas.map(row => row.map(item => item !== null ? item : '').join(',')) // 各データ行
      ].join('\n'); // 改行で結合

      // UTF-8 BOMを追加
      const bom = '\uFEFF';
      const csvWithBom = bom + csvContent;
      // CSV ファイルのダウンロード
      const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${action}_summary.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const paramsToGet = {
      command: 'resultget',
      output: action,
      id: id
    };
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet);
  }

  SurveySettingList () {
    const onSuccess = (res) => {
      const surveySettingList = res.body.data
      // `year` でソート
      const sortedSurveySettingList = surveySettingList.sort((a, b) => {
        // 降順ソート (新しい年が上に来る)
        return new Date(b.year) - new Date(a.year);
      })
      this.setState({
        isLoaded: true,
        surveySettingList: surveySettingList,
      })
    }
    const params = {
      command: 'get'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  renderSurveySettingListBox (state) {
    let surveySettingList = state.surveySettingList
    if(surveySettingList.length) {
      return surveySettingList
          .map((survey) => {
            return (
                <tr key={survey.id}>
                   <td onClick={(surveySetting, e) => this.selected(survey, e)} style={{verticalAlign: 'middle'}}>{survey.year}</td>
                   <td onClick={(surveySetting, e) => this.selected(survey, e)} style={{verticalAlign: 'middle'}}>{survey.title}</td>
                   <td onClick={(surveySetting, e) => this.selected(survey, e)} style={{verticalAlign: 'middle'}}>{survey.answerCount}</td>
                   <td onClick={(surveySetting, e) => this.selected(survey, e)} style={{verticalAlign: 'middle'}}>{survey.shimeFlg ? '締め済' : '締め前'}</td>
                   <td style={{verticalAlign: 'middle'}} width="15%"><button style={{width: '150px'}} className='btn btn-info btn-sm' onClick={() => this.toggleOutputCsvModal(survey.id)}>アンケート結果</button></td>
                   <td style={{verticalAlign: 'middle'}} width="15%"><button style={{width: '150px'}} className='btn btn-success btn-sm' onClick={() => this.toggleOutputTotalModal(survey.id)}>集計結果</button></td>
                </tr>
            )
          })
    } else {
      return (
          <tr>
             <td style={{textAlign: 'center'}} colspan="4">データがありません</td>
          </tr>
      )
    }
  }
  renderOutputCsv() {
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>アンケート結果</li>
        <li className='text-center'>
          出力したいアンケート結果を選択してください<br />
          <br />
          <button style={{width: '150px'}} className='btn btn-primary' onClick={(e) => this.onOutputCsvButtonClicked('katawaku', e)}>型枠工</button>　
          <button style={{width: '150px'}} className='btn btn-success' onClick={(e) => this.onOutputCsvButtonClicked('kaitai', e)}>解体工</button>　
          <button style={{width: '150px'}} className='btn btn-info' onClick={(e) => this.onOutputCsvButtonClicked('other', e)}>その他設問</button>
        </li>
        <li className='text-center'>
          <button style={{width: '150px', margin: '15px 0'}} className='btn btn-default' onClick={(e) => this.onOutputCsvButtonClicked('cancel', e)}>終了</button>
        </li>
      </ul>
    )
  }
  renderOutputTotal() {
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>集計結果</li>
        <li className='text-center'>
          出力したい集計結果を選択してください<br />
          <br />
          <button style={{width: '150px'}} className='btn btn-primary' onClick={(e) => this.onOutputTotalButtonClicked('katawaku', e)}>型枠工</button>　
          <button style={{width: '150px'}} className='btn btn-success' onClick={(e) => this.onOutputTotalButtonClicked('kaitai', e)}>解体工</button>　
        </li>
        <li className='text-center'>
          <button style={{width: '150px', margin: '15px 0'}} className='btn btn-default' onClick={(e) => this.onOutputTotalButtonClicked('cancel', e)}>終了</button>
        </li>
      </ul>
    )
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  zeroPack (text) {
    return ('0' + text).slice(-2)
  }
  convHttpLink (text) {
    const regExp = /(https?:\/\/\S+)/g
    return ReactStringReplace(text, regExp, (match, i) => (
      <a key={text} href={match} target='_blank'>{match}</a>
    ))
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const surveySettingList = this.renderSurveySettingListBox(this.state)
    const pageNavi = this.renderPageNavi()
    const outputCsvBox = this.renderOutputCsv()
    const outputTotalBox = this.renderOutputTotal()
    return (
      <div>
        {pageNavi}
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-info-sign icon-large' />
              <h5>アンケート情報</h5>
            </div>
            <div className='box-content box-table'>
              <table className='table table-hover tablesorter'>
                <thead>
                  <tr>
                    <th>年度</th>
                    <th>タイトル</th>
                    <th>現在の回答人数</th>
                    <th>アンケート締切</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {surveySettingList}
                </tbody>
              </table>
            </div>
            {this.state.isOutputCsvModalOpen && (
              <div className="modal">
                <div className="modal-content">
                  <span className="close" onClick={() => this.toggleOutputCsvModal()}>&times;</span>
                  {outputCsvBox}
                </div>
              </div>
            )}
            {this.state.isOutputTotalModalOpen && (
              <div className="modal">
                <div className="modal-content">
                  <span className="close" onClick={() => this.toggleOutputTotalModal()}>&times;</span>
                  {outputTotalBox}
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    )
  }
}

export default SurveySettingList



// WEBPACK FOOTER //
// ./src/common/pages/secure/SurveySettingList.js